import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var SuperScript = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.493 2.624c-.7-.7-1.899-.7-2.599 0l-.6.6c-.399.399-1.099.399-1.498 0-.4-.4-.4-1.1 0-1.5l.6-.6c1.498-1.499 3.997-1.499 5.596 0 1.5 1.5 1.5 3.998 0 5.597L33.894 9.82h3.798c.6 0 1 .5 1 1 0 .6-.5 1-1 1h-5.897c-1 0-1.699-1.3-.9-2.1l4.598-4.597c.7-.6.7-1.699 0-2.498ZM24.3 6.821v27.684c0 5.197-4.298 9.495-9.495 9.495-2.599 0-4.998-1.1-6.697-2.798-.4-.4-.4-1.1 0-1.5.4-.4 1.1-.4 1.5 0 1.399 1.4 3.198 2.2 5.197 2.2a7.38 7.38 0 0 0 7.396-7.397V21.213a9.332 9.332 0 0 1-7.396 3.598c-5.197 0-9.495-4.298-9.495-9.495V6.821c0-.6.5-1 1.1-1 .6 0 .999.5.999 1v8.495a7.38 7.38 0 0 0 7.396 7.396 7.38 7.38 0 0 0 7.396-7.396V6.821c0-.6.5-1 .999-1 .6 0 1.1.4 1.1 1Z"
  }));
});
SuperScript.displayName = 'SuperScript';
SuperScript.defaultProps = {
  'aria-label': 'SuperScript'
};
export default SuperScript;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Editor/SuperScript.js
// module id = 3562
// module chunks = 11